<template>
	<div>
		<div class="div-content">
			<div class="btn-add"><el-button size="mini" @click="add">新增</el-button></div>
			<!-- 表格 -->
			<el-table :data="tableData" max-height="350" border height="480" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
				<el-table-column type="index" label="编号" width="60px" />
				<el-table-column prop="name" min-width="150px" label="名称">
					<template #default="scope">
						<el-input v-model="scope.row.name" :disabled="!scope.row.isEdit" placeholder="请输入内容"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="url" min-width="150px" label="摄像头地址">
					<template #default="scope">
						<el-input v-model="scope.row.url" :disabled="!scope.row.isEdit" placeholder="请输入内容"></el-input>
					</template>
				</el-table-column>

				<!-- 操作 -->
				<el-table-column label="操作" width="80px" fixed="right">
					<template #default="scope">
						<div>
							<el-button type="text" v-if="!scope.row.id" @click="sheBeiPeiZhiBC(scope.$index)">{{ !scope.row.isEdit ? '编辑' : '保存' }}</el-button>
							<el-button type="text" v-if="scope.row.id" @click="bianJi(scope.row)">{{ !scope.row.isEdit ? '编辑' : '保存' }}</el-button>
							<el-button type="text" style="color: red;" v-if="scope.row.id" @click="shanChu(scope.$index, tableData)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'monitor',
	components: {},
	props: [],
	data() {
		return {
			ruleForm: {
				name: '',
				url: ''
			},
			rules: {
				url: [
					{
						required: true,
						message: '请输入摄像头地址',
						trigger: 'blur'
					}
				]
			},
			bridgeUuid: '',
			tableData: [],
			// 分页器
			pagination: {
				total: 0,
				per_page: 10,
				from: 1,
				to: 0,
				current_page: 1 //当前页数
			}
		};
	},
	mounted() {
		this.getMonitorList();
	},
	methods: {
		// 获取-部门名称列表
		async getMonitorList() {
			let data = {
				uuid: global.bridgeUuid
			};
			const res = await this.$api.sendGet('/biBridge/queryBridgeCamera', data);
			console.log('部门名称', res);
			if (res.errcode == 0) {
				if (res.data && res.data.length > 0) {
					this.tableData = res.data.map(item => {
						item.isEdit = false;
						return item;
					});
				} else {
					this.tableData = [];
				}
			}
		},
		save() {
			this.$refs.ruleForm.validate(async valid => {
				if (valid) {
					let data = {
						...this.ruleForm,
						uuid: this.bridgeUuid
					};
					let url = '';
					const res = await this.$api.sendPost('/biBridge/addOrUpdateCamera', data);
					console.log(res);
					if (res.errcode == 0) {
						this.$message.success(res.errmsg);
						// global.index = '1';
						// this.$emit('updateIndex', '2');
					} else {
						this.$message.error(res.errmsg);
					}
				} else {
					return false;
				}
			});
		},
		resetForm() {
			this.$refs.ruleForm.resetFields();
		},

		// 保存
		async sheBeiPeiZhiBC(index) {
			const list = JSON.parse(JSON.stringify(this.tableData));
			let data = {
				...list[index],
				uuid: this.bridgeUuid
			};
			const res = await this.$api.sendPost('/biBridge/addOrUpdateCamera', data);
			console.log(res);
			if (res.errcode == 0) {
				this.tableData[index].isEdit = false;
				this.$message.success(res.errmsg);
				this.getMonitorList();
			} else {
				this.$message.error(res.errmsg);
			}
		},
		// 编辑
		async bianJi(row) {
			let data = JSON.parse(JSON.stringify(row));
			if (row.isEdit) {
				const res = await this.$api.sendPost('/biBridge/addOrUpdateCamera', data);
				if (res.errcode == 0) {
					row.isEdit = false;
					this.$message.success(res.errmsg);
				} else {
					row.isEdit = true;
					this.$message.error(res.errmsg);
				}
			} else {
				row.isEdit = true;
			}
		},
		// 删除
		shanChu(index, rows) {
			console.log(rows);
			this.$confirm('是否确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					// 如果有设备类型uuid则调接口删除数据
					console.log(rows)
					if (rows[index].equipmentUuid) {
						console.log(rows[index]);
						const res = await this.$api.sendGet('/biBridge/deteleEquipment', {
							equipmentUuid: rows[index].equipmentUuid
						});
						if (res.errcode == 0) {
							rows.splice(index, 1);
							this.$message.success(res.errmsg);
						} else {
							this.$message.error(res.errmsg);
						}
					} else {
						rows.splice(index, 1);
						this.$message.success('删除成功');
					}
				})
				.catch(() => {
					this.$message.error('已取消操作');
				});
		},
		// 新增表格行
		add() {
			let obj = {
				name: '',
				url: '',
				isEdit: true
			};
			this.tableData.unshift(obj);
		}
	}
};
</script>

<style lang="scss" scoped>
.div-content {
	padding: 0 10px;
	box-sizing: border-box;
	height: 700px;
	overflow: auto;

	.btn-add {
		display: flex;
		padding-bottom: 20px;
	}
}

</style>
